define('performance',[
    "utilities",
    "logging"
], function(utilities, logging) {
    "use strict";

    var _ModuleName = "Performance Measurement Library";
    var _config = {
        enabled: true,
        developmentOnly: true
    };

    var _monitors = [];

    /**
     * Register a new monitor
     * @param {String} name Name of monitor
     */
    var registerMonitor = function(name) {
        if (!_enabled) { return; }

        ;

        var stamp = new Date();
        _monitors.push({
            name: name,
            complete: false,
            steps: [
                {
                    name: 'start',
                    stamp: stamp,
                    time: 0
                }
            ]
        });
    }

    /**
     * Mark off a step completed in a particular monitor
     * @param {String} name Name of monitor
     * @param {String} step Name of step completed
     */
    var tick = function(name, step) {
        if (!_enabled) { return; }

        var monitor = _monitors.find(function(m) { return m.name == name; });
        if (monitor && monitor.complete === false) {
            ;
            var stamp = new Date();
            monitor.steps.push(
                {
                    name: step,
                    stamp: stamp,
                    time: stamp.getTime() - monitor.steps[monitor.steps.length - 1].stamp.getTime()
                }
            );
        } else if (monitor && monitor.complete) {
            logging.error("Received request to register step [" + step + "] with completed monitor [" + name + "]", _ModuleName);
        } else {
            logging.error("Failed to find performance monitor [" + name + "]", _ModuleName);
        }

    }

    /**
     * Mark performance monitoring complete and print results to the console
     * @param {String} name Name of monitor
     */
    var complete = function(name) {
        if (!_enabled) { return; }

        console.log("Initial Page Load Start: " , window.bnm.performance.domReady);

        var monitor = _monitors.find(function(m) { return m.name == name; });
        if (monitor && monitor.complete === false) {
            ;
            monitor.complete = true;
            var stamp = new Date();
            monitor.steps.push(
                {
                    name: 'complete',
                    stamp: stamp,
                    time: stamp.getTime() - monitor.steps[monitor.steps.length - 1].stamp.getTime()
                }
            );
            
            console.log("Performance Monitor Results for " + monitor.name);
            console.table(monitor.steps, ["name", "time"]);
            console.log("Total Runtime: " + monitor.steps.map(function(s) { return s.time; }).reduce(function(total, num) { return total += num; }) + "ms");


        } else if (monitor && monitor.complete) {
            logging.error("Received request to complete an already completed monitor [" + name + "]", _ModuleName);
        } else {
            logging.error("Failed to find performance monitor [" + name + "] to mark complete", _ModuleName);
        }
    }

    /**
     * Check if performance monitoring is enabled and allowed to run
     */
    var _enabled = function() {
        return _config.enabled && (!_config.developmentOnly || utilities.isDevelopment());
    }

    return {
        registerMonitor: registerMonitor,
        tick: tick,
        complete: complete
    }
});
